// Mesmo padrão de AjusteGradeContext.js: guarda em memória (não em
// localStorage — some ao dar F5 ou fechar a aba, de propósito) o estado de
// filtro/visualização de GradeTurmas.js que hoje se perde ao trocar de menu —
// turno, modo (Atividade/Professor), buscas e quais áreas estão ativas. Como
// o Provider fica acima do <Router> em App.js, sobrevive à troca de rota.
//
// O que fica de fora de propósito: o modal aberto (turma selecionada, busca
// de aluno dentro dele, etc.) — isso é estado de UI transitório, não faz
// sentido reabrir um modal sozinho ao voltar pra tela.
//
// Reseta sozinho quando a instituição ativa muda, pra nunca herdar turno/área
// escolhidos numa instituição diferente.
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useInstitution } from '../../contexts/InstitutionContext';
import { AREAS } from '../../utils/areas';

const AREAS_ATIVAS_PADRAO = () => Object.fromEntries(AREAS.map((a) => [a.value, true]));

const GradeTurmasContext = createContext(null);

export function GradeTurmasProvider({ children }) {
  const { institutionId } = useInstitution();
  const [turnoSelecionado, setTurnoSelecionado] = useState('Manhã');
  const [modo, setModo] = useState('atividade');
  const [buscaProfessor, setBuscaProfessor] = useState('');
  const [buscaAtividade, setBuscaAtividade] = useState('');
  const [areasAtivas, setAreasAtivas] = useState(AREAS_ATIVAS_PADRAO);
  // Níveis (N1, N1.2, N2 etc., extraídos do nome da turma — ver nivelDaTurma
  // em GradeTurmas.js) escolhidos pra filtrar a grade. Vazio = sem filtro
  // (mostra todas), diferente de áreas (que já começam todas ativas).
  const [niveisSelecionados, setNiveisSelecionados] = useState([]);

  useEffect(() => {
    setTurnoSelecionado('Manhã');
    setModo('atividade');
    setBuscaProfessor('');
    setBuscaAtividade('');
    setAreasAtivas(AREAS_ATIVAS_PADRAO());
    setNiveisSelecionados([]);
  }, [institutionId]);

  return (
    <GradeTurmasContext.Provider
      value={{
        turnoSelecionado,
        setTurnoSelecionado,
        modo,
        setModo,
        buscaProfessor,
        setBuscaProfessor,
        buscaAtividade,
        setBuscaAtividade,
        areasAtivas,
        setAreasAtivas,
        niveisSelecionados,
        setNiveisSelecionados,
      }}
    >
      {children}
    </GradeTurmasContext.Provider>
  );
}

export function useGradeTurmasFiltros() {
  const ctx = useContext(GradeTurmasContext);
  if (!ctx) throw new Error('useGradeTurmasFiltros precisa estar dentro de <GradeTurmasProvider>');
  return ctx;
}
